import {useCallback, useMemo} from 'react';
import {calculateSlope} from '~/common/utils/math';
import {
  CARD_INITIAL_SCALE_LANDSCAPE,
  CARD_INITIAL_SCALE_PORTRAIT,
  CARD_RATIO_LANDSCAPE,
  CARD_RATIO_PORTRAIT,
  ENVELOPE_FINAL_SCALE_LANDSCAPE,
  ENVELOPE_FINAL_SCALE_PORTRAIT,
  WRAPPER_PADDING_DESKTOP_LANDSCAPE,
  WRAPPER_PADDING_DESKTOP_PORTRAIT,
} from '../animation-config';

interface UseAnimationSlopesParams {
  cardAspectRatio: number;
}

interface AnimationSlopes {
  cardScaleInit: number;
  envelopeScaleFinal: number;
  wrapperPaddingDesk: number;
}

export const useAnimationSlopes = ({
  cardAspectRatio,
}: UseAnimationSlopesParams): AnimationSlopes => {
  const calcSlope = useCallback(
    (y1: number, y2: number) =>
      calculateSlope(CARD_RATIO_LANDSCAPE, y1, CARD_RATIO_PORTRAIT, y2, cardAspectRatio),
    [cardAspectRatio]
  );

  const cardScaleInit = useMemo(() => {
    return calcSlope(CARD_INITIAL_SCALE_LANDSCAPE, CARD_INITIAL_SCALE_PORTRAIT);
  }, [calcSlope]);

  const envelopeScaleFinal = useMemo(() => {
    return calcSlope(ENVELOPE_FINAL_SCALE_LANDSCAPE, ENVELOPE_FINAL_SCALE_PORTRAIT);
  }, [calcSlope]);

  const wrapperPaddingDesk = useMemo(() => {
    return calcSlope(WRAPPER_PADDING_DESKTOP_LANDSCAPE, WRAPPER_PADDING_DESKTOP_PORTRAIT);
  }, [calcSlope]);

  return {
    cardScaleInit,
    envelopeScaleFinal,
    wrapperPaddingDesk,
  };
};
